/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsRefreshAodRunRunActionsMutationResponse, AuditReportsRefreshAodRunRunActionsPathParams, AuditReportsRefreshAodRunRunActions400, AuditReportsRefreshAodRunRunActions401, AuditReportsRefreshAodRunRunActions403, AuditReportsRefreshAodRunRunActions404 } from "../models/AuditReportsRefreshAodRunRunActions";

export function getAuditReportsRefreshAodRunRunActionsUrl(id: AuditReportsRefreshAodRunRunActionsPathParams["id"]) {
  const res = { method: 'PUT', url: `/audit-reports/v1/aod-runs/${id}/refresh` as const }
  return res
}

/**
 * @description Re-executes the AOD run job for runs with COMPLETED_WITHOUT_EXPORT status
 * @summary Refresh a run
 * {@link /audit-reports/v1/aod-runs/:id/refresh}
 */
export async function auditReportsRefreshAodRunRunActions(id: AuditReportsRefreshAodRunRunActionsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsRefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRefreshAodRunRunActions400 | AuditReportsRefreshAodRunRunActions401 | AuditReportsRefreshAodRunRunActions403 | AuditReportsRefreshAodRunRunActions404>, unknown>({ method : "PUT", url : getAuditReportsRefreshAodRunRunActionsUrl(id).url.toString(), ... requestConfig })
  return res.data
}